import PropTypes from 'prop-types'
import React, { Component } from 'react'
import './style.scss'
import {AiOutlineDelete} from 'react-icons/ai'

export class LineLabel extends Component {
  static propTypes = {}

  getStyles = () => {
    const {item} = this.props;
    return {
      left: item.startX > item.endX ? item.endX - 200 : item.endX,
      top: item.endY - 25,
    }
  }

  render() {
    const { deleteItem, onChange, item } = this.props;
    return (
      <div style={this.getStyles()} className='ItemQestionBlock'>
        <div className='icon' onClick={deleteItem}>
          <AiOutlineDelete color='#8F79EE' />
        </div>
        <textarea value={item.value} onChange={(e) => onChange(e.target.value)} />
      </div>
    )
  }
}

export default LineLabel


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/AnswerType6/components/LineLabel/LineLabel.jsx